import { Component, Input, OnInit, Pipe, PipeTransform } from '@angular/core';
import { LayoutService } from '../../layout.service';
import { RecordModel } from '../../record-model';
import {
  Section,
  ModuleStructure,
  Field,
} from 'src/app/models/module-structure';

@Component({
  selector: 'app-normal-section',
  templateUrl: './normal-section.component.html',
  styleUrls: ['./normal-section.component.less'],
})
export class NormalSectionComponent implements OnInit {
  @Input() moduleStructure: ModuleStructure;
  @Input() section: Section;
  @Input() recordModel: RecordModel;
  @Input() actionType = '';

  fields: Field[];
  fieldGroups: any;
  thereIsCenter: boolean;
  fieldGroupCount: number;
  fieldGroupKeys: any[];
  EditShipBill: boolean;

  constructor(
    private layoutService: LayoutService
  ) { }

  ngOnInit(): void {
    this.fields = this.section.Fields.sort((a, b) => a.SortOrder - b.SortOrder);
    //  console.log('fields>>', this.fields);
    for (let i = 0; i < this.moduleStructure.module.Sections.length; i++) {
      let section = this.moduleStructure.module.Sections[i];
      if (section.XmlTagName == this.section.XmlTagName) {
        section = this.section;
        break;
      }
    }

    this.fieldGroups = this.fields.reduce((acc, obj) => {
      let key = obj.PCAlignment;
      if (key == 0) {
        key = 1;
      }
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
    //  console.log('fieldGroups', this.fieldGroups);

    this.thereIsCenter =
      this.fields.filter((obj) => obj.PCAlignment == 4).length > 0;
    //  console.log('ddd', this.thereIsCenter);

    this.fieldGroupCount = Object.keys(this.fieldGroups).length;
    //  console.log('fieldGroupCount', this.fieldGroupCount);

    this.fieldGroupKeys = Object.keys(this.fieldGroups);

    for (const key of this.fieldGroupKeys) {
      this.fieldGroups[key] = this.fieldGroups[key].sort((field1, field2) => {
        return this.layoutService.compareObjects(field1, field2, 'SortOrder');
      });
    }
    if (this.section.AdditionalIdentifier == 'EditBill' || this.section.AdditionalIdentifier == 'EditShip') {
      this.EditShipBill = true;
    }
  }
  updateRelatedSection() {
    const DocumentsProperties = this.recordModel.Categories.find(x => x.Id == 'Documents').Lines[0].Properties;
    if (this.section.AdditionalIdentifier == 'EditBill') {
      const BillToCode = DocumentsProperties.find(x => x.Name == 'PayToCode').ValueAsObject;
    }
  }
  getAlignmentName(alingmentNumber: number): string {
    //  console.log('getAlignmentName');
    if (alingmentNumber == 0 || alingmentNumber == 1) {
      return 'left';
    }
    if (alingmentNumber == 2) {
      return 'right';
    }
    if (alingmentNumber == 3) {
      return 'extended';
    }
    if (alingmentNumber == 4) {
      return 'center';
    }
  }
}

@Pipe({
  name: 'keyValueFilter',
})
export class keyValueFilterPipe implements PipeTransform {
  transform(value: any, args: any[] = null): any {
    return Object.keys(value).map((key) => {
      const pair = {};
      const k = 'key';
      const v = 'value';

      pair[k] = key;
      pair[v] = value[key];

      return pair;
    });
  }
}


@Pipe({
  name: 'getSpanVal',
})
export class GetSpanValPipe implements PipeTransform {
  transform(value: any): number {
    if (value == 3) {
      return 24;
    } else {
      return 8;
    }
  }
}

@Pipe({
  name: 'getPushVal',
})
export class GetPushValPipe implements PipeTransform {
  transform(fieldKey: number, args: any): number {
    // console.log('getPushVal');
    if (args[0] == 1) {
      return 0;
    } else {
      if (fieldKey == 2) {
        return 8;
      } else {
        return 0;
      }
    }
  }
}


@Pipe({
  name: 'getPullVal',
})
export class GetPullValPipe implements PipeTransform {
  transform(fieldKey: number, args: any): number {
    // console.log('getPullVal');
    if (args[0] == 1) {
      return 0;
    } else {
      if (args[1] && fieldKey == 4) {
        return 8;
      } else {
        return 0;
      }
    }
  }
}
